import { format, parse } from 'date-fns'


export function addIndexesToPayrollEntries(payrollEntries = []) {
    if (!payrollEntries.length) return payrollEntries;

    return payrollEntries.map((entry, index) => {
        return {
            ...entry,
            index: index + 1
        }
    });
}

export function generateColumnsForDisplay(payrollEntries = [], allowances = []) {
    if (!payrollEntries.length) return [];

    let allowanceNames = allowances.map((allowance) => allowance.name);

    let baseColumns = Object.keys(payrollEntries[0])

    return Array.from(new Set([
        'index',
        'employee_name',
        'basic_pay',
        'amount_overtime',
        'amount_rest_days',
        'amount_rest_day_overtime',
        'amount_legal_holiday',
        'amount_legal_holiday_overtime',
        'amount_special_holiday',
        'amount_special_holiday_overtime',
        'other_income_non_taxable',
        'amount_night_diff',
        'hours_tardy',
        'gross_pay',
        'amount_13th_month',
        'total_pay',
        'sss_er',
        'sss_contribution',
        'nhip_contribution',
        'hdmf_contribution',
        'total_contribution',
        'gross_billing',
        "rest_day_legal_holiday",
        "rest_day_legal_holiday_amount",
        "rest_day_ot_legal_holiday_amount",
        "rest_day_special_holiday",
        "rest_day_special_holiday_amount",
        "rest_day_ot_special_holiday",
        "rest_day_ot_special_holiday_amount",
        ...baseColumns,
        ...allowanceNames,
    ]))
}

export function generateOtherDetailsBilling(billingDetails = {}) {
    if (!billingDetails) return billingDetails;

    //generate amount in words
    billingDetails.denomination = 'PHP'
    billingDetails.date = billingDetails?.createdAt ? format(new Date(billingDetails.createdAt), 'MMMM dd, yyyy') : ''

    return billingDetails
}   

export default {
    generateColumnsForDisplay,
    generateOtherDetailsBilling, 
    addIndexesToPayrollEntries
}